export default "__VITE_ASSET__BujYpXIq__"